import * as React from 'react';
import TextField from '@mui/material/TextField';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import {DatePicker, LocalizationProvider} from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {Stack} from "@mui/material";

import { formatDate2 } from '../../functions/formatters';

const FilterDatePicker2 = ({handleFunction, value, label})=>{
    let v = formatDate2(new Date());

    if (value) {
        v = formatDate2(value);
    }

    return (
        <TextField
            type={"date"}
            margin="normal"
            value={v}
            label={label}
            onChange={handleFunction}
            fullWidth
            InputLabelProps={{ shrink: true }}
        />

    );
}

export default FilterDatePicker2;
